import { Suspense, lazy } from "react";
import { IPerpsTradingHeaderProps } from "./PerpsTradingHeader";
import { TradingHeaderWrapper } from "../style";

const PerpsTradingHeader = lazy(
  () =>
    import(
      /* webpackChunkName: "PerpsTradingHeader" */
      /* webpackPrefetch: true */
      "./PerpsTradingHeader"
    )
);

function LazyPerpsTradingHeader({
  perpInstrument,
  isMobileScreen,
  isTradeForm,
}: IPerpsTradingHeaderProps) {
  return (
    <Suspense
      fallback={<TradingHeaderWrapper isMobileScreen={isMobileScreen} />}
    >
      <PerpsTradingHeader
        isMobileScreen={isMobileScreen}
        perpInstrument={perpInstrument}
        isTradeForm={isTradeForm}
      />
    </Suspense>
  );
}

export default LazyPerpsTradingHeader;
